import Diversity1Icon from '@mui/icons-material/Diversity1';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import VideoCameraFrontOutlinedIcon from '@mui/icons-material/VideoCameraFrontOutlined';
import Card from './components/Card';
import './styles/advantages.css'

function Advantages() {
    const init_advs = [
        {
            icon: <Diversity1Icon />,
            title: "Guadagni fino all'80%",
            text: "Guadagna fino all'80% per ogni video venduto",
            footer:"Un clic per vivere un sogno."
        },
        {
            icon: <VerifiedOutlinedIcon />,
            title: "Semplice e veloce",
            text: "Senza intermediari, hai la piena autonomia del tuo business e del tuo successo.",
            footer:"Solo legami autentici e certificati."
        },
        {
            icon: <VideoCameraFrontOutlinedIcon />,
            title: "Realizza il sogno di un fan",
            text: "Dona emozioni uniche con un messaggio personalizzato e autentico",
            footer: "Un ricordo esclusivo che dura per sempre."
        }
    ]
    return (
        <div className='advantages'>
            <h2>I vantaggi di HEQA</h2>
            <div className='card-container'>
                {init_advs.map((el) => <Card info={el} />)}
            </div>
        </div>)

}

export default Advantages